import styled from 'styled-components';

export default styled('table')`
  width: 100%;
  display: table;
  border-spacing: 0;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;

  thead {
    display: table-header-group;
    tr {
      color: inherit;
      display: table-row;
      outline: 0;
      vertical-align: middle;
      th {
        vertical-align: inherit;
        display: table-cell;
        border-bottom: 2px solid rgba(11, 47, 63, 0.2);
        text-align: left;
        padding: 30px 0;
        &:first-child {
          padding-left: 20px;
        }
        &:last-child {
          padding-right: 20px;
        }
        .cell {
          color: rgba(11, 47, 63, 0.4);
          font-size: 15px;
        }
      }
    }
  }
  tbody {
    display: table-row-group;
    tr {
      color: inherit;
      display: table-row;
      outline: 0;
      vertical-align: middle;
      border-bottom: 1px solid rgba(11, 47, 63, 0.2);
      &:last-child {
        border-bottom: none;
      }
      td {
        display: table-cell;
        padding: 20px 0;
        &:first-child {
          padding-left: 20px;
        }
        &:last-child {
          padding-right: 20px;
        }
        .cell {
          color: #0b2f3f;
          font-size: 14px;
        }
      }
    }
  }

  &.responsive {
    @media only screen and (max-width: 1023px) {
      thead {
        tr {
          th {
            &:first-child,
            &:last-child {
              padding-right: 5px;
            }
          }
        }
      }
      tbody {
        td {
          &:last-child {
            span {
              width: 100%;
              text-align: center;
              display: inline-block;
              padding: 10px 0;
            }
          }
        }
      }
    }

    @media screen and (max-width: 767px) {
      background-color: transparent;
      .hidden-mobile {
        display: none !important;
      }

      &.has-selector {
        tr {
          td:first-child {
            display: none;
          }
        }
      }

      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
        border-bottom: 2px solid #333;
      }

      tbody {
        tr {
          margin: 20px 0;
          background-color: #fff;
          border-radius: 4px;
          padding: 0.25em;
        }
        td {
          width: 100% !important;
          padding: 10px 20px;
          &:last-child {
            padding: 10px 20px;
          }
        }
        .cell {
          width: 100%;
          border: none !important;
          position: relative;
          text-align: left !important;
          white-space: pre-wrap;
          overflow-wrap: break-word;
          .actions {
            display: flex;
            justify-content: space-between;
            align-content: center;
            a {
              padding: 10px 20px;
            }
          }
        }
      }
    }
  }
`;
